angular.module("ainapp")
    .controller("master2Controller", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Master 2";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {
                $scope.City = {
                    Name: "",
                    Field1: "",
                    Field2: "",
                    Field3: "",
                    Field4: "",
                    Field5: "",
                    Field6: "",
                    Field7: "",
                    Field8: "",
                    Field9: "",
                    Field10: "",
                }
                $scope.load = 0;
            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.Master2sInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Name: {
                                type: "string",
                                editable: false,
                            },
                            Field1: {
                                type: "string",
                                editable: false,
                            },
                            Field2: {
                                type: "string",
                                editable: false,
                            },
                            Field3: {
                                type: "string",
                                editable: false,
                            },
                            Field4: {
                                type: "string",
                                editable: false,
                            },
                            Field5: {
                                type: "string",
                                editable: false,
                            },
                            Field6: {
                                type: "string",
                                editable: false,
                            },
                            Field7: {
                                type: "string",
                                editable: false,
                            },
                            Field8: {
                                type: "string",
                                editable: false,
                            },
                            Field9: {
                                type: "string",
                                editable: false,
                            },
                            Field10: {
                                type: "string",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "Name",
                        title: "City Name",
                        headerTemplate: "{{LanguageData.Name}}",
                        },
                    {
                        field: "Field1",
                        title: "Field1",
                        headerTemplate: "{{CompanyProfile.Master2Feild1}}",
                        },
                    {
                        field: "Field2",
                        title: "Field2",
                        headerTemplate: "{{CompanyProfile.Master2Feild2}}",
                        }, {
                        field: "Field3",
                        title: "Field3",
                        headerTemplate: "{{CompanyProfile.Master2Feild3}}",
                        },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                        width: '80px'
                    },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteMaster2($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data == "Success") {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    } else {
                        toastr.error(response.data);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }


            $scope.Edit = function (data) {
                $scope.City = data;
                //$scope.$apply();
            }

            $scope.AddData = function () {
                if (!$scope.PageAccessInfo.IsAdd && !$scope.City.Id > 0) {
                    toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.City.Id > 0) {
                    toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");

                } else if ($scope.City.Name == "") {
                    toastr.warning("Enter Name");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddMaster2($scope.City).then(function (response) {
                        if (response.data == "Success") {
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            toastr.success("Success");
                            $scope.Init();
                        } else {
                            toastr.error(response.data);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }
            }

                }])
